import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

export default function ProductsCTA() {
  const { t } = useLanguage();

  const steps = [
    { icon: 'ri-file-list-3-line', text: t('告訴我們您的產品應用與目標物性', 'Tell us your product application and target properties', '製品用途と目標物性をお知らせください') },
    { icon: 'ri-box-3-line', text: t('說明現有原料種類與設備條件', 'Describe your existing raw material types and equipment conditions', '既存の原料種類と設備条件をご説明ください') },
    { icon: 'ri-team-line', text: t('聚量團隊規劃最佳導入組合', 'PolyQ team plans the optimal implementation combination', '聚量チームが最適な導入組み合わせを計画します') },
    { icon: 'ri-rocket-line', text: t('快速評估，3 個工作天內回覆', 'Quick assessment, reply within 3 business days', '迅速な評価、3営業日以内にご返信') },
  ];

  return (
    <section className="relative section-padding overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#F0FAF6] via-[#EBF4FF] to-[#F5F8FB]" />
      <div className="absolute top-0 right-0 w-[500px] h-[500px] opacity-50 pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(0,184,148,0.14) 0%, transparent 65%)' }} aria-hidden="true" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] opacity-35 pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(2,115,194,0.10) 0%, transparent 65%)' }} aria-hidden="true" />

      <div className="relative z-10 max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br from-brand-green to-brand-blue mb-6">
              <i className="ri-customer-service-2-line text-white text-2xl"></i>
            </div>
            <h2
              className="font-bold text-neutral-dark mb-5"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
            >
              {t(
                '想導入再生塑料，卻擔心物性與風險？',
                'Want to Adopt Recycled Plastics but Worried About Properties and Risks?',
                '再生プラスチックを導入したいが、物性とリスクが心配ですか？'
              )}
            </h2>
            <p className="text-neutral-mid mb-8" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
              {t(
                '告訴我們您的產品應用、現有原料與設備條件，聚量團隊可協助規劃 PQernel、rvPlastics 與 PQMB 的最佳導入組合。',
                'Tell us your product application, existing raw materials, and equipment conditions. The PolyQ team can help plan the optimal implementation combination of PQernel, rvPlastics, and PQMB.',
                '製品用途・既存原料・設備条件をお知らせください。聚量チームがPQernel・rvPlastics・PQMBの最適な導入組み合わせを計画します。'
              )}
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-brand-green text-white text-[1.0625rem] font-semibold hover:bg-brand-green-dark transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-schedule-line"></i>
              {t('預約技術諮詢', 'Schedule Technical Consultation', '技術相談を予約')}
            </Link>
          </div>

          <div className="bg-white rounded-2xl border border-neutral-border p-7" style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.07)' }}>
            <p className="text-[1rem] font-semibold text-brand-green uppercase tracking-widest mb-6">
              {t('諮詢流程', 'Consultation Process', '相談プロセス')}
            </p>
            <div className="space-y-5">
              {steps.map((s, idx) => (
                <div key={idx} className="flex items-start gap-4">
                  <div className="flex flex-col items-center flex-shrink-0">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-brand-green-light">
                      <i className={`${s.icon} text-brand-green text-lg`}></i>
                    </div>
                    {idx < steps.length - 1 && <div className="w-px h-5 bg-neutral-border mt-1" />}
                  </div>
                  <div className="pt-2">
                    <span className="text-neutral-dark text-[1.0625rem] leading-relaxed">{s.text}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
